// The server keeps each browser push subscription against one user. The portal
// used to register only when the browser had no subscription yet, so an admin
// logging in on a browser another admin had used was never registered: pushes
// aimed at them went nowhere, and the previous admin's pushes kept arriving in
// that browser. Remember who the subscription was registered for, and register
// it again whenever that isn't the current user.

export interface WebPushOwner {
    userId: string;
    endpoint: string;
}

// Anything that isn't a stored owner (nothing saved, or the bare endpoint older
// versions saved) reads as unknown, so the subscription is registered once more.
export function readWebPushOwner(raw: string | null): WebPushOwner | null {
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        return typeof parsed?.userId === 'string' && typeof parsed?.endpoint === 'string'
            ? { userId: parsed.userId, endpoint: parsed.endpoint }
            : null;
    } catch {
        return null;
    }
}

export function isRegisteredFor(
    owner: WebPushOwner | null,
    userId: string,
    endpoint: string,
): boolean {
    return owner?.userId === userId && owner?.endpoint === endpoint;
}

export function webPushOwnerValue(userId: string, endpoint: string): string {
    return JSON.stringify({ userId, endpoint });
}
